<template>
    <div class="login-box">
        <em class="logo ng-scope"></em>
        <div class="login-form">
            <div class="col col-md-4 centered my-auto">
                <div class="login-text ng-scope">
                    <h3>Recovery Email Sent</h3>
                    <p>If that email address is a valid Cortex account, we have sent you an email to assist you in resetting your password.</p>
                    <div class="actions">
                        <p class="centered">
                            <a class="login-text text-center" v-on:click="returnToLogin()">Back to sign in</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
export default {
  data: () => ({
    email: ''
  }),
  methods: {
    returnToLogin () {
      this.$router.push('/login');
    }
  }
};
</script>

<style scoped type="scss">
.logo {
    overflow: hidden;
    background: url(/static/img/logo.png);
    background-size: 288px 90px;
    width: 288px;
    height: 90px;
    margin: auto;
}

#send-email {
    width: 100%;
    background-color: rgb(0, 168, 202) !important;
    color: white;
}

.login-text {
    width: 420px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/user/ForgotSent.vue